import React from 'react';
import { asBlock } from '../../_lib/BlockFetcher';
import { BlockType } from '../../types/api/ElementType';
import { DefaultView, Views } from '../../types/BlockWithViews';
import { isNullOrUndefined } from '../../lib/typeGuards';
import ContentMessage from '../../_lib/components/ContentMessage/ContentMessage';
import { KeywordsAToZ } from './partials/KeywordsAToZ';
import { useSonTranslation } from '../../translation/useSonTranslation';
import ILink from '../../types/ILink';

type KeywordsIndex = {
  keywords: Record<string, ILink[]>;
};

type KeywordsIndexProps = Views<DefaultView<KeywordsIndex>> | null;

function KeywordIndex(embedded: KeywordsIndexProps) {
  const { t } = useSonTranslation('KeywordIndex');

  if (isNullOrUndefined(embedded)) {
    return <ContentMessage text={t('noKeywords')} />;
  }

  return <KeywordsAToZ keywordsAToZ={embedded.views.default.embedded.keywords} />;
}

export const KeywordIndexBlock = asBlock(KeywordIndex, BlockType.keywordindex);
